export const SET_LANG = 'SET_LANG';



export const setLang = (lang) => ({
    type : SET_LANG,
    lang : lang
});


// WEBPACK FOOTER //
// ./src/redux/actions/lang.js